<template>
  <div class="chat-manager height-full">
    <ImManagerContact
        @select="onSelect"
        :companiesObj="companiesObj"></ImManagerContact>
    <div class="chat-flex-1 height-full">
      <ChatContainer
          role="manager"
          v-if="selectedPeerId"
          :title="memberName"
          :messages="memberMsgList"
          @send="onSend"></ChatContainer>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {SharedRtmInfo} from '@/components/mixins';
import ChatContainer from '@/components/ChatContainer';
import ImManagerContact from '@/components/ImManagerContact';
import {getMemberMetaInfo, getMemberName, setMemberName} from '@/http';

export default {
  name: 'ImManager',
  components: {ChatContainer, ImManagerContact},
  mixins: [SharedRtmInfo],
  props: {
    options: Object,
  },
  data() {
    return {
      activeIdx: -1,
      filterName: '',
      selectedPeerId: null,
      selectedMember: null,
      companiesObj: {},
    };
  },
  computed: {
    memberName() {
      return (this.selectedMember || {}).name;
    },
    memberMsgList() {
      return (this.companiesObj[this.selectedPeerId] || {}).list || [];
    },
  },
  methods: {
    onJoinPublicChannel(channel, args) {
      const {options: {accountId}} = this;
      (args || []).forEach(clientId => {
        const tellMeMsg = {me: accountId, type: 'tellMe'};
        this.sendPeerMessage(tellMeMsg, clientId);
      });
    },
    findPeerDetail(peerId) {
      const {companiesObj} = this;
      const peer = companiesObj[peerId] || {meta: {name: getMemberName(peerId)}, list: []};
      if (!companiesObj[peerId]) {
        companiesObj[peerId] = peer;
        if (!peer.meta.name) {
          getMemberMetaInfo(peerId).then(name => {
            peer.meta.name = name;
          });
        }
      }
      return peer;
    },
    // 客服人员接受的消息肯定是用户发送的
    onMessageFromPeer(message, peerId) {
      const msg = JSON.parse(message.text);
      const {text, accountId, name} = JSON.parse(msg);
      setMemberName(accountId, name);
      const peer = this.findPeerDetail(peerId);
      const item = this.newMessageItem(text, peerId, 'accept');
      peer.list.push(item);
      this.$emit('notify', text, item.name);
    },
    onSelect(peerId, member) {
      this.selectedPeerId = peerId;
      this.selectedMember = member;
    },
    onSend(text) {
      const {selectedPeerId} = this;
      if (selectedPeerId) {
        this.sendPeerMessage(text, selectedPeerId).then(status => {
          if (!status.hasPeerReceived) {
            this.sendFailed(text, selectedPeerId);
          }
        }, () => this.sendFailed(text, selectedPeerId));
        const peer = this.findPeerDetail(selectedPeerId);
        const item = this.newMessageItem(text, selectedPeerId, 'send');
        peer.list.push(item);
      } else {
        console.warn('Ignored message: ', text);
      }
    },
    sendFailed(text, accountId) {
      this.$emit('notifyError', `[发送失败]${text}`, '[提醒]发送失败');
      const item = this.newMessageItem(`[发送失败]“${text}”，已离线!`, accountId, 'error');
      const peer = this.findPeerDetail(accountId);
      peer.list.push(item);
    },
  },
  created() {
    this.$emit('hook:created');
  },
};
</script>

<style lang="scss" scoped>
.chat-manager {
  display: flex;
  width: 720px;
}

.height-full {
  height: 100%;
}

.chat-flex-1 {
  flex: 1;
}
</style>